import { Notification } from 'models/notifications';
import { BaseTypes } from 'services/client/const';
import { getRequest } from 'services/client';

export const getListNotifications = async () => {
  const { data } = await getRequest<Notification>('notifications', BaseTypes.policies);
  return data;
};
